import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

const ATTRIBUTION_KEY = 'ref_attribution';

// 仅允许站内相对路径，防止 landing_page 被配置成外站导致开放重定向
const safePath = (p) => {
  if (typeof p !== 'string' || !p.startsWith('/') || p.startsWith('//')) return '/';
  return p;
};

export default function RefLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; // StrictMode 下防止双跑
    ranRef.current = true;

    const go = (path) => navigate(safePath(path), { replace: true });
    const c = String(code || '').trim().toUpperCase().slice(0, 20);
    if (!c) { go('/'); return; }

    api.get(`/referral/validate/${encodeURIComponent(c)}`)
      .then((res) => {
        if (!res.data?.valid) { go('/'); return; }
        const target = safePath(res.data.landingPage || '/');
        // 最后点击覆盖，注册时优先使用（30 天内有效）
        try {
          localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify({ code: c, ts: Date.now() }));
        } catch { /* 隐私模式等存储失败不阻断 */ }
        // 点击追踪异步上报，失败不影响跳转
        api.post('/referral/track-click', { code: c, landing_page: target }).catch(() => {});
        go(target);
      })
      .catch(() => go('/'));
  }, [code, navigate]);

  return (
    <div style={{
      minHeight: '100vh', background: '#F8F5F0',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Noto Sans SC', sans-serif", gap: 12,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 6, background: '#8C1F1F',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#F5E6D0', fontSize: 11, fontWeight: 700, lineHeight: 1.1,
        textAlign: 'center', letterSpacing: 1,
      }}>云川<br/>中古</div>
      <div style={{ fontSize: 13, color: '#6B5E4E' }}>正在进入云川中古…</div>
    </div>
  );
}
